<header class="relative z-10 bg-surface border-b border-border shadow-lg w-full px-4 flex justify-between items-center">
  <div class="h-14 sm:pl-4 pr-1 flex items-center min-w-0">
    @if (title()) {
      <span class="text-lg font-semibold text-content truncate">{{ title() }}</span>
    }
  </div>
  <div class="flex gap-4 shrink-0">
    <lib-language-switcher [inputLanguage]="currentLanguage()" (languageChanged)="languageChanged($event)"></lib-language-switcher>
    <lib-dark-mode-toggle [(isDark)]="isDark"></lib-dark-mode-toggle>
  </div>
</header>
